import { cn } from "@/lib/utils";

export const Panel = ({ className, children, testId, ...props }) => (
  <div
    className={cn("bg-surface border border-line rounded-lg", className)}
    data-testid={testId}
    {...props}
  >
    {children}
  </div>
);

export const Overline = ({ children, className }) => (
  <div className={cn("text-[11px] font-semibold uppercase tracking-widest text-ink-tertiary", className)}>
    {children}
  </div>
);

export const PageHeader = ({ title, subtitle, actions, testId }) => (
  <div className="flex items-start justify-between mb-3 gap-4 shrink-0" data-testid={testId}>
    <div>
      <h1 className="font-heading font-extrabold text-xl lg:text-2xl tracking-tight text-ink">{title}</h1>
      {subtitle && <p className="text-sm text-ink-secondary mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </div>
);
